<template>
  <div class="card h-100">
    <div class="card-body">
      <div class="font-weight-bold mb-3">
        FDM Result
      </div>

      <div class="result-item">
        <div class="result-label text-muted">
          {{ result.fit.label }}
        </div>
        <div class="result-value font-weight-bold">
          {{ result.fit.value }} ({{ formatPercent(result.fit) }})
        </div>
        <div class="progress mt-2">
          <div
            class="progress-bar"
            :style="{ width: `${clampPercent(result.fit)}%`, backgroundColor: result.fit.color }"
          />
        </div>
      </div>

      <div class="result-item">
        <div class="result-label text-muted">
          {{ result.followUp.label }}
        </div>
        <div class="result-value font-weight-bold">
          {{ result.followUp.value }} ({{ formatPercent(result.followUp) }})
        </div>
        <div class="progress mt-2">
          <div
            class="progress-bar"
            :style="{ width: `${clampPercent(result.followUp)}%`, backgroundColor: result.followUp.color }"
          />
        </div>
      </div>

      <div class="result-item">
        <div class="result-label text-muted">
          {{ result.unfit.label }}
        </div>
        <div class="result-value font-weight-bold">
          {{ result.unfit.value }} ({{ formatPercent(result.unfit) }})
        </div>
        <div class="progress mt-2">
          <div
            class="progress-bar"
            :style="{ width: `${clampPercent(result.unfit)}%`, backgroundColor: result.unfit.color }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    },
    totalResponded: {
      type: Number,
      default: null
    }
  },

  methods: {
    percentValue (item) {
      const total = Number(this.totalResponded) || Number(item.total) || 0
      const value = Number(item.value) || 0
      if (!total) return 0
      return (value / total) * 100
    },
    clampPercent (item) {
      const percent = this.percentValue(item)
      const clamped = Math.min(100, Math.max(0, percent))
      return Math.round(clamped * 10) / 10
    },
    formatPercent (item) {
      const clamped = this.clampPercent(item)
      if (clamped === 100) return '100.0%'
      if (clamped === 0) return '0%'
      if (Number.isInteger(clamped)) return `${clamped}%`
      return `${clamped.toFixed(1)}%`
    }
  }
}
</script>

<style scoped>
.result-item + .result-item {
  margin-top: 20px;
}

.result-label {
  font-size: 13px;
  line-height: 1.2;
}

.result-value {
  font-size: 13px;
  margin-top: 2px;
}

.progress {
  background-color: #dedede;
  border-radius: 999px;
  height: 28px;
}

.progress-bar {
  border-radius: 999px;
}
</style>
